export const pluralize = (count: number, word: string, plural?: string) => {
  return count === 1
    ? word
    : (plural ?? `${word}${word.endsWith('s') ? '' : 's'}`);
};
